import { PayerUserType } from "constants/payer";
import { createContext } from "react";
import { CheckoutDataProps } from "./CheckoutModal";
import { BANK_PAYMENT_METHOD, CARD_PAYMENT_METHOD } from "constants/billing";

type UseCreditsProps = {
  useCredits: boolean;
  setUseCredits: (value: boolean) => void;
  useBrexPoints: boolean;
  setUseBrexPoints: (value: boolean) => void;
};

type EntityChangeProps = {
  setEntityId: (value: string) => void;
  isEntityProvided: boolean;
};

type SelectPaymentThrough = {
  paymentThrough: typeof CARD_PAYMENT_METHOD | typeof BANK_PAYMENT_METHOD;
  setPaymentThrough: (
    value: typeof CARD_PAYMENT_METHOD | typeof BANK_PAYMENT_METHOD
  ) => void;
};

type SelectPaymentMethod = {
  paymentMethodId: string | null;
  setPaymentMethodId: (id: string) => void;
};

type Steps = {
  step: "DETAILS" | "PAYMENT";
  setStep: (value: "DETAILS" | "PAYMENT") => void;
};

type CheckoutModalCreditPropsContext = {
  type: "credits";
  creditsToBeAdded: number;
  setCreditsToBeAdded: (credits: number) => void;
} & EntityChangeProps &
  SelectPaymentMethod &
  SelectPaymentThrough;

type CheckoutModalInvoicesPropsContext = {
  type: "invoices";
  paymentMethodId: string | null;
  setPaymentMethodId: (id: string) => void;
} & UseCreditsProps &
  SelectPaymentMethod &
  EntityChangeProps &
  SelectPaymentThrough;

export type RecurringPaymentConsent = {
  isRecurringPaymentConsentRequire: boolean;
  setRecurringPaymentRequire: (value: boolean) => void;
  isRecurringPaymentConsent: boolean;
  setRecurringPaymentConsent: (value: boolean) => void;
  isRecurringPaymentConsentError: boolean;
  setRecurringPaymentConsentError: (value: boolean) => void;
};

type CheckoutModalSubscriptionPropsContext = {
  type: "subscription";
} & SelectPaymentMethod &
  EntityChangeProps &
  SelectPaymentThrough;

type CheckoutModalCartPropsContext = {
  type: "cart";
} & UseCreditsProps &
  SelectPaymentMethod &
  SelectPaymentMethod &
  SelectPaymentThrough &
  RecurringPaymentConsent;

type CheckoutModalTaskPropsContext = {
  type: "task";
} & UseCreditsProps &
  SelectPaymentMethod &
  SelectPaymentThrough;

type ContextUnion =
  | CheckoutModalCreditPropsContext
  | CheckoutModalInvoicesPropsContext
  | CheckoutModalSubscriptionPropsContext
  | CheckoutModalCartPropsContext
  | CheckoutModalTaskPropsContext;

export type CheckoutModalPropsContextType = {
  entityId: string;
  payerUserType: PayerUserType;
  invoiceRequestId?: string;
} & CheckoutDataProps &
  ContextUnion &
  Steps & {
    groupId: string;
  };

export const CheckoutModalPropsContext = createContext<
  CheckoutModalPropsContextType | undefined
>(undefined);
